export const CLOUDFRONT_FONTS_LINK = process.env.CLOUDFRONT_FONTS_LINK;
